// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2TKqX","actions":"styles_actions__2_TR3","error":"styles_error__ZUNcp","message":"styles_message__1Ya1M"};